import { render } from "./content-placeholders-heading.vue?vue&type=template&id=732d08ca&ts=true"
import script from "./content-placeholders-heading.vue?vue&type=script&lang=ts"
export * from "./content-placeholders-heading.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__